import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import PageBanner from "../../components/PageBanner";

/* The copy is lifted out of the supplied About Us banner artwork, where it was
   baked into the picture, and set as HTML instead: the tagline and the four
   strengths from its strip. The page's H1 ("About MBA Solutions") stays in
   AboutIntro directly below, so it is not repeated here. */
const STRENGTHS = [
  "Experienced Professionals",
  "International Standards Expertise",
  "Client Focused Approach",
  "Driving Sustainable Growth",
];

const AboutBanner = () => (
  <PageBanner
    image="/assets/banners/about-banner.webp"
    imageAlt="The MBA Solutions team working together in the company office"
    focus="60% 55%"
    ariaLabel="About MBA Solutions"
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <p className="page-banner__eyebrow">About Us</p>
      <p className="page-banner__title">
        Expertise. Integrity. <em>Excellence.</em>
      </p>
      <ul className="about-banner__strengths">
        {STRENGTHS.map((item) => (
          <li key={item}>
            <FiCheckCircle aria-hidden="true" /> {item}
          </li>
        ))}
      </ul>
    </motion.div>
  </PageBanner>
);

export default AboutBanner;
